import React from 'react';
import { motion } from 'framer-motion';
import Translator from '../i18n/Translator'

const Modal = ({ setSelectedImg, selectedImg, title }) => {

  const handleClick = (e) => {
    if (e.target.classList.contains('backdrop')) {
      setSelectedImg(null);
    }
  }

  return (
    <div>
 <motion.div className="backdrop" onClick={handleClick}
   initial={{ opacity: 0 }}
   animate={{ opacity: 1 }}
 >
   <motion.img src={selectedImg} alt="enlarged pic" 
     initial={{ y: "-100vh" }}
     animate={{ y: 0 }}
   />
<div className="photo-modal">
     <h5>{title}</h5>
{/* <a href={selectedImg} download target="_blank" className="xsmall-button"  ><Translator path="PhotoDownload" /></a> */}
</div>
 </motion.div>
 </div>
   )
}

export default Modal;